import { Link } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "src/components/Alert";
import ServerPaginationTable from "src/components/ServerPaginationTable";
import SyncStatus from "src/components/SyncStatus";
import TooltipText from "src/components/TooltipText";
import { loadConfig, loadJob, loadOrders, syncOrders } from "src/redux/actions/tradelink";
import { getQueryParams } from "src/utils/Utility";

function Orders() {
  const [syncStatus, setSyncStatus] = useState("enabled");
  const orders = useSelector((state) => state.tradelink.orders);
  const dispatch = useDispatch();
  const job = useSelector((state) => state.tradelink.job);
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [status, setStatus] = useState([]);
  const [sortBy, setSortBy] = useState();
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const config = useSelector((state) => state.tradelink.config);

  useEffect(() => {
    const financialDates = getFinancialStartEndDate();
    const { startDate, endDate } = getDateRange(financialDates);
    dispatch(loadConfig());
    dispatch(loadJob());
  }, [dispatch]);

  const data = useMemo(() => orders.data, [orders]);

  const columns = useMemo(
    () => [
      {
        Header: "TradeLink Order Number",
        accessor: "tradeLinkOneOrderNumber",
      },
      //hide: column for now
      // {
      //   Header: "Shipment Date",
      //   accessor: "shipmentDate",
      //   disableSortBy: true,
      // },
      {
        Header: "Order Date",
        accessor: "poReceivedDate",
        disableSortBy: true,
      },
      {
        Header: "Customer Name",
        accessor: "customerName",
      },
      {
        Header: "Deskera Order Number",
        accessor: "deskeraDocumentSequenceCode",
      },
      //hide: column for now
      // {
      //   Header: "Deskera ID",
      //   accessor: "deskeraId",
      // },
      {
        Header: "Sync Status",
        accessor: "syncStatus",
        Cell: ({ cell: { row } }) => {
          return (
            <SyncStatus
              status={row.original.syncStatus}
              reason={row.original.syncRemark}
              id={String(row.original.id)}
            />
          );
        },
        disableGlobalFilter: true,
      },
      {
        Header: "Remarks",
        accessor: "syncRemark",
        // disableSortBy: true,
        Cell: ({ cell: { row } }) => {
          return (
            <>
              {row.original.syncRemark && (
                <TooltipText 
                  text={row.original.syncRemark}
                  maxLength={50}
                  showTooltip={true}
                />
              )}
            </>
          );
        },
      },
      //hide: column for now
      // {
      //   Header: "Created At",
      //   accessor: "createdAt",
      //   disableSortBy: true,
      //   Cell: ({ cell: { value } }) => {
      //     if (!value) return "";
      //     return new Date(value).toLocaleDateString();
      //   },
      // },
    ],
    []
  );

  useEffect(() => {
    setLoading(false);
    if (data && data.totalPages) {
      setPageCount(data.totalPages);
    }
  }, [data]);

  function getFinancialStartEndDate() {
    let startDate = new Date().setDate(new Date().getDate() - 7);
    const endDate = new Date();
    startDate = new Date(startDate);
    return { startDate, endDate };
  }

  function getDateRange(financialDates) {
    let endDate = "";
    let startDate = "";
    if (!financialDates?.startDate || !financialDates.endDate) {
      return { startDate, endDate };
    }
    var sd = financialDates.startDate;
    var startMonth = sd.getMonth() + 1;
    var ed = financialDates.endDate ? financialDates.endDate : financialDates.startDate;
    var endMonth = ed.getMonth() + 1;
    endDate =
      ed.getUTCFullYear() +
      "-" +
      String(endMonth).padStart(2, "0") +
      "-" +
      String(ed.getDate()).padStart(2, "0");
    startDate =
      sd.getUTCFullYear() +
      "-" +
      String(startMonth).padStart(2, "0") +
      "-" +
      String(sd.getDate()).padStart(2, "0");
    return { startDate, endDate };
  }

  const refreshData = ({ pageSize, pageIndex, status, sortBy, startDate, endDate, search, query }) => {
    setPageSize(pageSize);
    setPageIndex(pageIndex);
    setStatus(status);
    setSortBy(sortBy);
    setLoading(true);
    setStartDate(startDate);
    setEndDate(endDate);
    
    const queryParams = getQueryParams(query);
    
    dispatch(loadOrders(pageSize, pageIndex, status, sortBy, startDate, endDate, search ?? "", queryParams));
  };

  const migrateTradelinkOrders = async (body) => {
    return await dispatch(syncOrders(body));
  };

  return (
    <div className="p-4">
      <h3 className="mb-3">Orders</h3>
      {(!config.data || !config.data.tradeLinkOneUserid || !config.data.tradeLinkOneApiKey ) && (
        <Alert type="warning">
          Your synced orders will appear here. Please complete{" "}
          <Link to="/app/tradelink" className="text-alert-warning">
            <u>Setup</u>
          </Link>{" "}
          before continuing.
        </Alert>
      )}
      
      <ServerPaginationTable
        data={data.content ? data.content : []}
        columns={columns}
        migrate={migrateTradelinkOrders}
        cart="tradelink"
        refresh={refreshData}
        tab="Orders"
        pageCount={pageCount}
        loading={loading}
        rowId="id"
      />
    </div>
  );
}

export default Orders; 